import { useState } from 'react';

export type Search = {
  country?: string[];
  description?: string[];
  employees?: string[];
  industry?: string[];
  raised?: string[];
  tag?: string[];
  tech?: string[];
  type?: string[];
};

const useTargetMarket = () => {
  const [search, setSearch] = useState<Search | null>(null);
  const [dirty, setDirty] = useState(false);
  const [id, setId] = useState<string | null>(null);

  const newSetSearch = (search: Search) => {
    setSearch(search);
    setDirty(true);
  };

  const setTargetMarket = ({
    search,
    id,
  }: {
    search: Search | null;
    id: string | null;
  }) => {
    setSearch(search);
    setId(id);
    setDirty(false);
  };

  return {
    search,
    setSearch: newSetSearch,
    dirty,
    id,
    setTargetMarket,
  };
};

export { useTargetMarket };
